export const radarOption = {
  // color: ["#00f2f1", "#525EED", "#56ef78", "#ff9f7f", "#0096ff", "#E60137"],
  tooltip: {
    // show: true,
    trigger: "item",

    // axisPointer: {
    //   type: "shadow",
    // },
  },
  legend: {
    orient: "vertical",
    x: "left",
    y: "top",
    data: ["代表全国指标得分率情况", "代表所选指标得分率情况"],
  },
  polar: [
    {
      indicator: [
        { text: "首约及时率", max: 100 },
        { text: "首约上门准时率", max: 100 },
        { text: "安装快准率", max: 100 },
        { text: "终约及时率", max: 100 },
        { text: "3天内维修完结率", max: 100 },
        { text: "5天内维修完结率", max: 100 },
        { text: "APP完工率", max: 100 },
        { text: "不满意工单占比", max: 100 },
        { text: "京东安装差评率", max: 100 },
        { text: "京东售后满意度", max: 100 },
        { text: "京东安装好评提及率", max: 100 },
        { text: "天猫完工准时率", max: 100 },
      ],
    },
  ],
  series: [
    {
      name: "指标",
      type: "radar",
      data: [
        {
          value: [
            4300, 10000, 28000, 35000, 50000, 19000, 20000, 17000, 25000, 54000,
            11000,
          ],
          name: "代表全国指标得分率情况",
        },
        {
          value: [
            5000, 14000, 28000, 31000, 42000, 21000, 22200, 21000, 29000, 64000,
            12300,
          ],
          name: "代表所选指标得分率情况",
        },
      ],
    },
  ],
};

export function createRateSlot(labels) {
  return function formatter(params) {
    console.log(params);
    let tooltipContent = params.name + "<br>";
    let index = 0;

    params.data.value.forEach((param) => {
      tooltipContent += `${params.marker} ${labels[index]}: ${param}%<br/>`;
      index++;
    });

    return tooltipContent;
  };
}

export const radarCategories = [
  {
    name: "代表全国指标达成率情况",
    code: "all",
  },
  {
    name: "代表所选指标达成率情况",
    code: "select",
  },
];

export const radarSeries = [
  {
    name: "首约及时率",
    code: "timelyAppointmentRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "首约上门准时率",
    code: "onTimeFirstVisitRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "安装快准率",
    code: "sameDayCompletionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "终约及时率",
    code: "finalAppointmentTimelyRate",
    type: "line",
  },
  {
    name: "3天内维修完结率",
    code: "repairWithinThreeDaysRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "5天内维修完结率",
    code: "repairWithinFiveDaysRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "APP完工率",
    code: "appCompletionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "不满意工单占比",
    code: "unsatisfiedOrderRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "京东安装差评率",
    code: "jdInstallationNegativeReviewRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "京东售后满意度",
    code: "jdAfterSalesSatisfactionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
];
